var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStirLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 177,
    viewBox: "0 0 144 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.8243 102.949C79.3661 102.949 78.9407 102.818 78.548 102.523L1.0211 43.4535C0.104788 42.7335 -0.0915653 41.4245 0.628397 40.5082C1.34836 39.5918 2.65738 39.3955 3.5737 40.1155L81.1006 99.1524C82.0169 99.8723 82.2132 101.181 81.4933 102.098C81.0679 102.654 80.4461 102.949 79.8243 102.949Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.3368,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8238 102.949C79.4311 102.949 79.0057 102.818 78.6457 102.589C77.6967 101.935 77.4349 100.626 78.0894 99.6767L133.068 19.1718C133.723 18.2228 135.032 17.961 135.981 18.6155C136.93 19.27 137.192 20.579 136.537 21.5281L81.5583 102C81.1329 102.622 80.4783 102.949 79.8238 102.949Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.3368,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0823 172.687C90.0678 172.687 89.1842 171.967 89.0206 170.92L77.763 101.182C77.5667 100.037 78.3521 98.9567 79.4975 98.7603C80.6429 98.564 81.7228 99.3494 81.9192 100.495L93.1768 170.233C93.3731 171.378 92.5877 172.458 91.4423 172.655C91.3114 172.687 91.2132 172.687 91.0823 172.687Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.3368,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1695 176.058C69.155 176.058 68.2714 175.338 68.1077 174.291C67.9114 173.146 68.6968 172.066 69.8422 171.869L111.698 165.095C112.844 164.899 113.924 165.684 114.12 166.829C114.316 167.975 113.531 169.055 112.385 169.251L70.5294 176.025C70.3985 176.058 70.2676 176.058 70.1695 176.058Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.3368,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0074 72.6454C66.9966 72.6454 64.0513 71.6964 61.5642 69.8965C58.4225 67.6384 56.3608 64.3004 55.739 60.4715C55.1172 56.6426 56.0335 52.8137 58.2916 49.7048C60.5497 46.5631 63.8877 44.5014 67.7166 43.8796C71.5127 43.2578 75.3416 44.1742 78.4833 46.4322C81.6249 48.6903 83.6866 52.0283 84.3084 55.8572C85.5847 63.744 80.2177 71.1728 72.3309 72.4491C71.5782 72.58 70.7928 72.6454 70.0074 72.6454ZM70.0728 47.9049C69.5165 47.9049 68.9929 47.9376 68.4365 48.0358C65.7203 48.4612 63.3641 49.9339 61.7605 52.1592C60.157 54.3845 59.5024 57.1008 59.9606 59.817C60.386 62.5332 61.8587 64.8894 64.084 66.493C66.3094 68.0965 69.0256 68.7511 71.7418 68.2929C77.3379 67.3766 81.134 62.1078 80.2505 56.5117C79.3669 51.5047 75.0144 47.9049 70.0728 47.9049Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.3368,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6166 49.8028C76.2239 49.8028 75.8311 49.7046 75.4712 49.4428C74.4894 48.7883 74.2276 47.4793 74.8821 46.5302L104.891 1.17258C105.546 0.190814 106.822 -0.0709904 107.804 0.583521C108.786 1.23803 109.048 2.54706 108.393 3.4961L78.351 48.8537C77.9583 49.4755 77.3038 49.8028 76.6166 49.8028Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.3368,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3207 54.0903L16.5329 54.0575C15.3875 54.0575 14.4385 53.1085 14.4385 51.9631C14.4385 50.8177 15.3875 49.8687 16.5329 49.8687L42.3207 49.9014C43.4661 49.9014 44.4151 50.8504 44.4151 51.9958C44.4151 53.1412 43.4661 54.0903 42.3207 54.0903Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.3368,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.488 54.1552H95.3034C94.158 54.1552 93.209 53.2061 93.209 52.0607C93.209 50.9153 94.158 49.9663 95.3034 49.9663H110.488C111.633 49.9663 112.583 50.9153 112.583 52.0607C112.615 53.2061 111.666 54.1552 110.488 54.1552Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.3368,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.88 129.13C134.444 125.923 129.273 122.716 122.859 119.803L125.182 114.469L115.038 117.774L119.554 127.428L121.583 122.749C133.658 128.214 140.596 134.562 139.713 139.34C139.353 141.238 137.814 142.907 135.066 144.315C132.186 145.82 128.062 146.965 123.153 147.653C112.649 149.093 99.1329 148.438 85.0936 145.82C71.0543 143.202 58.2259 138.915 48.9319 133.744C44.5794 131.323 41.1432 128.77 39.016 126.316C36.987 123.992 36.1362 121.865 36.4961 120C37.4124 115.156 46.3465 111.753 59.8622 111.066L59.6986 107.858C52.4989 108.218 46.3465 109.364 41.8959 111.131C36.8561 113.16 33.9763 115.942 33.3218 119.411C32.8636 121.767 33.5181 124.221 35.2198 126.708C35.6125 127.297 36.0707 127.854 36.5616 128.443C38.9833 131.192 42.5831 133.941 47.3283 136.559C56.8842 141.86 70.0726 146.278 84.4391 148.962C98.8056 151.645 112.681 152.332 123.546 150.827C128.913 150.074 133.298 148.864 136.538 147.162C140.171 145.264 142.298 142.809 142.854 139.929C143.541 136.461 141.84 132.828 137.88 129.13Z",
    fill: "#1E1D1D",
    stroke: "#1E1D1D",
    strokeWidth: 0.3368,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStirLogo);
export default __webpack_public_path__ + "static/media/stir-logo.2244a5870f262e59334358461bfdb546.svg";
export { ForwardRef as ReactComponent };